import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';
import type { MarketDayTypeCardsResponse } from '@/types/api';

export interface MarketDayTypeParams {
  startDate: string;
  endDate: string;
}

export function useMarketDayTypeCards(params: MarketDayTypeParams) {
  return useQuery({
    queryKey: ['market-day-types', params.startDate, params.endDate],
    queryFn: async () => {
      const res = await apiClient.get<MarketDayTypeCardsResponse>('/market-day-types/cards', {
        params: {
          start_date: params.startDate,
          end_date: params.endDate,
        },
      });
      return res.data;
    },
    enabled: Boolean(params.startDate && params.endDate),
    staleTime: 5 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
  });
}
